import { View } from "binder"
import { BarcodeReaderViewModel } from "./barcodeReader-viewModel"

export class BarcodeReaderView extends View<BarcodeReaderViewModel>{
    GetViewUniqueId(): string {
        return "V-AA0C50FE-BC68-44C5-8B1D-1927CACFCF55"
    }
    loadHtml(): string {
        let element = require('./barcodeReader.html').default;
        let style = require('./barcodeReader.less');
        return element;
    }
    constructor() {
       super();
    }

    public set ReadCode(v: string) { this._ReadCode = v; } public get ReadCode(): string { return this._ReadCode;} private _ReadCode: string;

}
